import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgBatteryFull = function SvgBatteryFull(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22.5 9H21V7.5A1.5 1.5 0 0019.5 6h-18A1.5 1.5 0 000 7.5v9A1.5 1.5 0 001.5 18h18a1.5 1.5 0 001.5-1.5V15h1.5a1.5 1.5 0 001.5-1.5v-3A1.5 1.5 0 0022.5 9zm-5 .5v5a.5.5 0 01-.5.5h-1.5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5H17a.5.5 0 01.5.5zm-4 5v-5A.5.5 0 0013 9h-1.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5H13a.5.5 0 00.5-.5zm-4-5v5a.5.5 0 01-.5.5H7.5a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5H9a.5.5 0 01.5.5zm-4 5v-5A.5.5 0 005 9H3.5a.5.5 0 00-.5.5v5a.5.5 0 00.5.5H5a.5.5 0 00.5-.5z",
    clipRule: "evenodd"
  }));
};

export default SvgBatteryFull;